import { render } from "./Popover.vue?vue&type=template&id=85900d6e&scoped=true&ts=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=85900d6e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85900d6e"]])

export default __exports__